import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../../theme';

export const StyledLabel = styled('label')`
    display: block;
    margin-bottom: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(0.5), 2)};
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
`;

export const StyledInput = styled('div')`
    margin-bottom: ${({ theme }) => theme.tggSpacing(px(20), 5)};
`;
